import React from 'react';
import {Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';

const {text, text2} = translations['pt-br'].privateFlow.therapyBooking.alerts.needAuth;

export function NeedAuthDescription() {
	return (
		<Typography
			textAlign="center"
			data-tag-id={FinishWithoutCompleteFlowEnum.NECESSARIO_ENCAMINHAMENTO_MEDICO}>
			{text}
			<br />
			<br />
			{text2}
		</Typography>
	);
}
